import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderEntity } from '../../domain/entities/OrderEntity'
import type { OrderAdminDto } from '@/backend/market'
export class OrderModel extends OrderEntity {
  constructor(dataDto: OrderAdminDto) {
    super()
    mapEntityProperties<OrderEntity>(this, dataDto, {
      map: {
        region: {
          id: dataDto.serviceRegionId
        }
      }
    })
  }
}
